/** Русские названия групп vue3-emoji-picker */
export const EMOJI_GROUP_NAMES_RU = {
  smileys_people: 'Смайлы и люди',
  animals_nature: 'Животные и природа',
  food_drink: 'Еда и напитки',
  activities: 'Активности',
  travel_places: 'Путешествия и места',
  objects: 'Объекты',
  symbols: 'Символы',
  flags: 'Флаги',
} as const

export const EMOJI_STATIC_TEXTS_RU = {
  placeholder: 'Поиск эмодзи',
  skinTone: 'Тон кожи',
} as const
